export const healthcareSchema = {
  "@context": "https://schema.org",
  "@type": "MedicalOrganization",
  "@id": "https://scienzahealth.com/#medical-organization",
  "name": "Scienza Health",
  "alternateName": "Digital Human® AI Platform",
  "description": "Advanced AI-powered Digital Human® platform transforming healthcare delivery through patient access automation, clinical support, and care optimization",
  "url": "https://scienzahealth.com",
  "logo": {
    "@type": "ImageObject",
    "url": "https://scienzahealth.com/mcai_logo_green.svg",
    "width": "400",
    "height": "400"
  },
  "image": {
    "@type": "ImageObject",
    "url": "https://scienzahealth.com/images/scienza_social_preview.png",
    "width": "1200",
    "height": "630"
  },
  "medicalSpecialty": [
    "Cognitive Health Assessment",
    "Patient Access Solutions",
    "Clinical Decision Support",
    "Healthcare AI Integration"
  ],
  "serviceType": [
    "Digital Human® Patient Interaction",
    "AI-Powered Clinical Screening",
    "Automated Care Coordination",
    "Intelligent Health Monitoring"
  ],
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Digital Human® Healthcare Solutions",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Cognitive Screening & Intake",
          "description": "AI-powered cognitive health screening and patient intake automation",
          "serviceType": "Medical Assessment Technology"
        }
      },
      {
        "@type": "Offer", 
        "itemOffered": {
          "@type": "Service",
          "name": "Clinical Automation",
          "description": "Automated clinical workflows and decision support systems",
          "serviceType": "Healthcare Process Automation"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service", 
          "name": "Patient Access Solutions",
          "description": "Digital Human® powered patient access and engagement platforms",
          "serviceType": "Patient Engagement Technology"
        }
      }
    ]
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "customer service",
    "url": "https://scienzahealth.com/contact"
  },
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "US"
  }
};